<ng-container *ngIf="initialized">
    @if (dto) {
        <div (click)="handleClick()" class="pointer">
            <inline-template-component
                    [objectType]="'cm.Contract'"
                    [name]="dto.contractTypeDtoName"
                    [startDate]="dto.startDate"
                    [endDate]="dto.endDate"
                    [status]="dto.baseStatusEnumName"
                    [statusIcon]="dto.baseStatusEnumImage"
                    [statusColor]="dto.baseStatusEnumColor"
                    [statusColorBackground]="dto.baseStatusEnumColorBackground"
                    [buttons]="toolbarButtons"
                    (onButtonClick)="handleButtonClick($event)">
            </inline-template-component>
            <div class="flex align-items-center gap-1 mr-2 ml-3 mt-1 text-sm text-700">
                <span class="ellipses" pTooltip="Partner Name"
                      tooltipPosition="bottom">{{ dto?.partnerDto?.shortName }}</span>
            </div>
        </div>
    }
</ng-container>